/* eslint-disable no-mixed-operators */
/* eslint-disable import/prefer-default-export */
import api from 'shared/services/api';
import { ACTION_TYPE } from './actionTypes';
import { getSimulationData } from 'shared/redux/selectors';

const submitAppointmentPending = () => ({
  type: ACTION_TYPE.SUBMIT_APPOINTMENT_PENDING,
});

const submitAppointmentSuccess = () => ({
  type: ACTION_TYPE.SUBMIT_APPOINTMENT_SUCCESS,
});

const submitAppointmentFailure = error => ({
  type: ACTION_TYPE.SUBMIT_APPOINTMENT_FAILURE,
  payload: error,
});

export const submitAppointment = data => dispatch => new Promise((resolve) => {
  dispatch(submitAppointmentPending());
  api.submitAppointment(data)
    .then(() => {
      dispatch(submitAppointmentSuccess());
      resolve();
    })
    .catch(error => dispatch(submitAppointmentFailure(error.data)));
});


export const sendEmail = data => dispatch => new Promise((resolve) => {
  api.sendEmail(data)
    .then((result) => {
      dispatch({
        type: ACTION_TYPE.SEND_EMAIL_SUCCESS,
        payload: result.refCode,
      });
      resolve(result.refCode);
    })
    .catch(error => console.log(error));
});

const assetAllocationRefCodeSuccess = payload => ({
  type: ACTION_TYPE.ASSET_ALLOC_REF_CODE_SUCCESS,
  payload,
});

const assetAllocationRefCodeFail = payload => ({
  type: ACTION_TYPE.ASSET_ALLOC_REF_CODE_FAIL,
  payload,
})

export const generatePDf = () => (dispatch, getState) => new Promise((resolve) => {
  const data = getSimulationData(getState());
  const isSendEmail = data.clientEmail === '' ? false : true;
  api.generatePdf(data, isSendEmail)
    .then(res => {
      // console.log('ref code from action ', res)
      dispatch(assetAllocationRefCodeSuccess(res.refCode));
      resolve(res.refCode);
    })
    .catch(err => dispatch(assetAllocationRefCodeFail(err)));
})